import {
  resetAttribute,
  removeNull,
  getSameAttribute,
  getLevelArray
} from '@/utils/handleData.js'
export default {
  namespaced: true,
  state: {
    measureType: '', // 计量类型
    measureList: [], // 缓存计量台帐列表
    currentMeasure: {}, // 当前选择期次计量
    measureDetail: [] // 缓存某期次计量明细
  },
  getters: {
    safetyMeasureStatistics(state, getters, rootState) {
      var safetyMeasureStatistics = []
      if (state.measureType === '安全计量') {
        safetyMeasureStatistics = JSON.parse(
          JSON.stringify(rootState.safetyInput.securityFundType)
        )
        safetyMeasureStatistics.forEach((item) => {
          delete item.children
          const details = state.measureDetail.filter((detail) => {
            return item.securityFundType === detail.securityFundType
          })
          item.declaredAmount = getSameAttribute(
            details,
            'declaredAmount'
          ).addValue
          item.amountReviewedByResident = getSameAttribute(
            details,
            'amountReviewedByResident'
          ).addValue
          item.amountReviewedByDirector = getSameAttribute(
            details,
            'amountReviewedByDirector'
          ).addValue
          item.amountReviewedByProject = getSameAttribute(
            details,
            'amountReviewedByProject'
          ).addValue
        })
      }
      return safetyMeasureStatistics
    },
    safetyMeasureDetail(state, getters, rootState, rootGetters) {
      var safetyMeasureDetail = []
      if (state.measureType === '安全计量') {
        const measureState = state.currentMeasure.measureState
        var safetyUseAccount = JSON.parse(
          JSON.stringify(rootState.safetyInput.safetyUseAccount)
        )
        var noMeasuredAccount = safetyUseAccount.filter((item) => {
          item.children = item.children.filter((child) => {
            return child.measureState !== '全部计量'
          })
          return (
            item.checkStatus === '已核查' &&
            item.measureState !== '全部计量' &&
            (item.useType === '非物资采购' ||
              (item.useType === '安全物资采购' && item.isHasInbound))
          )
        })
        var accountUids = []
        var useDetailUids = []
        if (state.measureDetail.length) {
          let params = {
            uid: 'accountUid',
            childUid: 'uid',
            childLabel: 'expenseName',
            sumKeys: [
              'declaredAmount',
              'amountReviewedByResident',
              'amountReviewedByDirector',
              'amountReviewedByProject'
            ]
          }
          safetyMeasureDetail = getLevelArray(state.measureDetail, params)
          accountUids = getSameAttribute(safetyMeasureDetail, 'uid').values
          useDetailUids = getSameAttribute(
            state.measureDetail,
            'useDetailUid'
          ).values
        }
        if (measureState === 5 || measureState === 6) {
          safetyMeasureDetail = safetyMeasureDetail.concat(
            noMeasuredAccount.filter((item) => {
              return !accountUids.includes(item.uid)
            })
          )
        }
        safetyMeasureDetail.forEach((item) => {
          const account = safetyUseAccount.find((account) => {
            return item.uid === account.uid
          })
          item.account = JSON.parse(JSON.stringify(account))
          item.measureState = item.account.measureState
          item.expenseAmount = item.account.useAmount
          item.investAmount = item.account.investAmount
          item.measuredAmount = item.account.measuredAmount
          item.checkReportUid = item.account.checkReportUid
          item.orgUid = item.account.orgUid
          item.detailForm = item.account.detailForm
          item.invoiceImg = getSameAttribute(
            item.account.fileLists.invoiceImg,
            'url'
          ).values
          item.otherEnclosure = getSameAttribute(
            item.account.fileLists.otherEnclosure,
            'url'
          ).values
          item.srcList = item.account.srcList
          if (measureState !== 6) {
            item.children = item.children.concat(
              item.account.children.filter((child) => {
                return !useDetailUids.includes(child.uid)
              })
            )
          }
          item.children.forEach((child) => {
            const measure = item.account.useDetails.find((detail) => {
              return (
                child.uid === detail.uid || child.useDetailUid === detail.uid
              )
            })
            child.account = JSON.parse(JSON.stringify(measure ? measure : []))
            child.measureState = child.account.measureState
            child.expenseAmount = child.account.expenseAmount
            child.measuredAmount = child.account.measuredAmount
              ? child.account.measuredAmount
              : 0
            child.declaredAmount =
              child.declaredAmount && child.declaredAmount !== 0
                ? child.declaredAmount
                : child.declaredAmount === 0
                ? 0
                : child.expenseAmount - child.measuredAmount
            child.amountReviewedByResident = child.amountReviewedByResident
              ? child.amountReviewedByResident
              : rootGetters['user/orgBuildType'] !== '总承包单位' &&
                measureState === 4
              ? child.declaredAmount
              : 0
            child.amountReviewedByDirector = child.amountReviewedByDirector
              ? child.amountReviewedByDirector
              : rootGetters['user/orgBuildType'] !== '总承包单位' &&
                measureState === 3
              ? child.amountReviewedByResident
              : 0
            child.amountReviewedByProject = child.amountReviewedByProject
              ? child.amountReviewedByProject
              : rootGetters['user/orgBuildType'] !== '总承包单位' &&
                measureState === 2
              ? child.amountReviewedByDirector
              : 0
            if (rootState.pageStatus === 'check') {
              if (measureState === 4) {
                child.opinion = child.opinionReviewedByResident
              } else if (measureState === 3) {
                child.opinion = child.opinionReviewedByDirector
              } else if (measureState === 2) {
                child.opinion = child.opinionReviewedByProject
              }
            }
          })
          item.declaredAmount = getSameAttribute(
            item.children,
            'declaredAmount'
          ).addValue
          item.amountReviewedByResident = getSameAttribute(
            item.children,
            'amountReviewedByResident'
          ).addValue
          item.amountReviewedByDirector = getSameAttribute(
            item.children,
            'amountReviewedByDirector'
          ).addValue
          item.amountReviewedByProject = getSameAttribute(
            item.children,
            'amountReviewedByProject'
          ).addValue
          item.showButtons = false
          item.disabled = true
        })
      }
      return safetyMeasureDetail
    }
  },
  mutations: {},
  actions: {
    // 添加计量期次
    async addMeasure({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fund/measure',
          data: data,
          msg: '新增计量期次成功'
        },
        { root: true }
      )
      return res
    },
    // 删除计量期次
    async deleteMeasure({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/fund/measure',
          data: { uid: uid },
          msg: '删除计量期次成功'
        },
        { root: true }
      )
      return res
    },
    // 上报或审核计量
    async confirmMeasure({ state, dispatch }, params) {
      const measureState =
        params.state === '审批拒绝'
          ? 0
          : state.currentMeasure.measureState === 0
          ? 5
          : state.currentMeasure.measureState - 1
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fund/uploadmeasure',
          data: { uid: params.uid, measureState: measureState },
          msg: '上报或审核计量成功'
        },
        { root: true }
      )
      return res
    },
    // 获取安全经费计量列表
    async getSafetyMeasureList({ commit, dispatch }) {
      var queryValues = await dispatch(
        'bidSection/ensureDefaultBidQuery',
        { queryKey: 'safetyMeasure', fieldKey: 'projectUid' },
        { root: true }
      )
      queryValues = Object.assign({}, queryValues)
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/fund/measure', data: queryValues },
        { root: true }
      )
      var measureList = res.data ? res.data : []
      measureList.forEach((item) => {
        item.measure = resetAttribute(item.measure, 'measurePeriod', 'uid')
        item.measure.forEach((child) => {
          child.disabledButtons = []
          child.period = '第' + child.measurePeriod + '期'
          if (child.measureState === 6) {
            child.status = '未编制'
          } else if (child.measureState === 5) {
            child.status = '未申报'
          } else if (child.measureState === 4) {
            child.status = '驻地办审核'
            child.disabledButtons = ['', 1]
          } else if (child.measureState === 3) {
            child.status = '总监办审核'
            child.disabledButtons = ['', 1]
          } else if (child.measureState === 2) {
            child.status = '项目办审核'
            child.disabledButtons = ['', 1]
          } else if (child.measureState === 1) {
            child.status = '审批通过'
            child.disabledButtons = ['', 1]
          } else if (child.measureState === 0) {
            child.status = '审批拒绝'
          }
          child.measureDetail = child.measureDetail ? child.measureDetail : []
          child.refuseNum = child.measureDetail.reduce((per, cur) => {
            return cur.measureState === 0 ? per++ : per
          }, 0)
          child.declaredAmount = getSameAttribute(
            child.measureDetail,
            'declaredAmount'
          ).addValue
          child.amountReviewedByResident = getSameAttribute(
            child.measureDetail,
            'amountReviewedByResident'
          ).addValue
          child.amountReviewedByDirector = getSameAttribute(
            child.measureDetail,
            'amountReviewedByDirector'
          ).addValue
          child.amountReviewedByProject = getSameAttribute(
            child.measureDetail,
            'amountReviewedByProject'
          ).addValue
        })
      })
      commit(
        'baseSet',
        {
          module: 'measure',
          key: 'measureType',
          value: '安全计量'
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'measure',
          key: 'measureList',
          value: measureList
        },
        { root: true }
      )
    },
    // 获取安全经费计量明细
    async getSafetyMeasureDetail({ rootState, commit, dispatch }, params) {
      const data = {
        orgUid: rootState.user.orgValue,
        projectUid: rootState.queryValues.safetyMeasure.projectUid,
        year:
          rootState.currentRow.safetyMeasure &&
          rootState.currentRow.safetyMeasure.declaredDate
            ? new Date(
                rootState.currentRow.safetyMeasure.declaredDate
              ).getFullYear()
            : new Date().getFullYear()
      }
      dispatch('safetyInput/getSafetyUseAccount', data, { root: true })
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fund/measuredetail',
          data: {
            uid:
              params && params.uid
                ? params.uid
                : rootState.currentUids.measureDetail
          }
        },
        { root: true }
      )
      var measureDetail = res.data ? res.data : []
      //console.log(measureDetail)
      commit(
        'baseSet',
        {
          module: 'measure',
          key: 'measureDetail',
          value: measureDetail
        },
        { root: true }
      )
    },
    // 批量添加计量明细
    async addSafetyMeasureDetail({ state, dispatch }) {
      const data = JSON.parse(JSON.stringify(state.measureDetail)).filter(
        (item) => {
          return item.declaredAmount
        }
      )
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fund/measuredetail',
          data: data,
          msg: '添加安全资金计量明细成功'
        },
        { root: true }
      )
      return res
    },
    // 批量编辑计量明细
    async editSafetyMeasureDetail({ state, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fund/measuredetail',
          data: state.measureDetail,
          msg: '编辑安全资金计量明细成功'
        },
        { root: true }
      )
      return res
    }
  }
}
